<template>
    <brick-settings-base 
        v-if="show"
        v-model="newName"
        :title="resource('JourneyComposer_BrickSettingsTouchpoint_Title')"
        :canWrite="canWrite"
        :prompt="{
            title: resource('JourneyBuilder_TouchpointSettings_Delete_Title'),
            body: resource('JourneyBuilder_TouchpointSettings_Delete_Body')
        }"
        
        @save="save"
        @delete="$emit('delete')"
        @hidden="$emit('hide')"
    >
    
        <settings-item icon="fas fa-hand-point-right">

            <template v-slot:label>
                <label for="type">{{fieldName}}</label>
            </template>

            <template v-slot:input>
                <v-select class="form-control" id="type"
                    v-model="selectedTouchPointType"
                    label="name"
                    :options="touchPointTypes"
                    :disabled="!canWrite"
                    :clearable="false"

                    searchable
                    filterable
                >
                    <div slot="no-options" />
                </v-select>
            </template>

        </settings-item>
    
    </brick-settings-base>
</template>

<script>

import BrickSettingsBase from './BrickSettingsBase.vue';
import brickSettingsMixin from '../../../Mixins/brick-settings'

export default {
    name: 'journey-brick-settings-touchpoint',
    mixins: [brickSettingsMixin],
    components: {
        BrickSettingsBase
    },
    created() {
        this.getTouchPoints((types) => {
            this.touchPointTypes = types;
        });
    },
    methods: {
        save() {
            this.settings.icon = this.touchPointTypes.find((type) => 
                type.id === this.settings.touchPointTypeId
            ).icon;
            
            this.saveSettings();
        }
    },
    computed: {
        selectedTouchPointType: {
            get(){
                return this.touchPointTypes.find(t => t.id === this.settings.touchPointTypeId);
            },
            set(value){
                this.settings.touchPointTypeId = value ? value.id : undefined;
            }
        }
    },
    data() {
        return {
            touchPointTypes: [],
            fieldName: this.resource('JourneyComposer_BrickSettingsTouchpoint_Type_DisplayName')
        };
    }
};
</script>

<style lang="scss" scoped>

</style>